import * as Icons from "@mui/icons-material";

const IntroIconModel = [
    {
        icon : <Icons.LinkedIn />,
        link : "https://www.linkedin.com/in/sathishwebdev"
    },
    {
        icon : <Icons.GitHub />,
        link : "https://www.github.com/sathishwebdev"
    },
    {
        icon : <Icons.Mail />,
        href : "mailto:sathishweb27@gmail.com"
    },
    {
        icon : <Icons.Phone />,
        href:"tel:+918940800307"
    }
]



export default IntroIconModel